import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStackPlus12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconImageStackPlus12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 8a4 4 0 0 1-4-4H1.5a.5.5 0 0 0-.5.5v3.746L2.652 6.64l.381-.37.347.404L6.23 10H7.5a.5.5 0 0 0 .5-.5zM4.126 3a4 4 0 0 1 .41-1H3.5a.5.5 0 0 0-.5.5V3zm1.228-2A4 4 0 0 1 11 6.646V8.5A1.5 1.5 0 0 1 9.5 10h-.585A1.5 1.5 0 0 1 7.5 11h-6A1.5 1.5 0 0 1 0 9.5v-5A1.5 1.5 0 0 1 1.5 3H2v-.5A1.5 1.5 0 0 1 3.5 1zM10 7.465q-.466.27-1 .409V9h.5a.5.5 0 0 0 .5-.5zM8 2a.57.57 0 0 0-.571.571v.858H6.57a.571.571 0 0 0 0 1.142h.858v.858a.571.571 0 1 0 1.143 0V4.57h.857a.571.571 0 0 0 0-1.142h-.857V2.57A.57.57 0 0 0 8 2m-6.5 8h3.413L2.967 7.73 1.016 9.624A.5.5 0 0 0 1.5 10"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStackPlus12);
